/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2DocumentHeart/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2DocumentHeart({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2DocumentHeart",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2DocumentHeart.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-LJfd9': alignSelf,'--mt-2-LJfd9': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-LJfd9': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-LJfd9': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-LJfd9': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-LJfd9': opacity,'--w-10-LJfd9': typeof width === 'number' ? `${width}px` : width,'--h-11-LJfd9': typeof height === 'number' ? `${height}px` : height,'--f-12-LJfd9': fill,'--a-7-LJfd9': isAnimated ? animation : "none",'--sd-8-LJfd9': isAnimated ? strokeDashoffset : 0,'--sd-9-LJfd9': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2DocumentHeart.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M.377.377C.617.135.945 0 1.286 0h6.857c.71 0 1.286.576 1.286 1.286v4.873c-.165.071-.325.158-.48.26a2.799 2.799 0 00-1.347-.473 2.514 2.514 0 00-1.965.752c-.913.916-1.24 2.64-.009 3.842l.02.019.631.584H1.286A1.286 1.286 0 010 9.857V1.286C0 .945.135.618.377.376zM2.036 2.57c0-.295.24-.535.535-.535h4.286a.536.536 0 110 1.071H2.571a.536.536 0 01-.535-.536zm0 2.572c0-.296.24-.536.535-.536h2.572a.536.536 0 110 1.072H2.57a.536.536 0 01-.535-.536zm4.34 4.63l2.28 2.113a.429.429 0 00.583 0l2.28-2.113c1.44-1.406-.634-4.132-2.57-1.937-1.938-2.195-4.012.531-2.572 1.937z"
 style={{'--f-12-LJfd9': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}